import type { useCasinoLobbyStore } from "@/casino/store/casinoLobby.store"
import { ref } from "vue"

export function useCasinoData(
  emit: any,
  casinoLobbyStore: ReturnType<typeof useCasinoLobbyStore>,
) {
  const categories = ref([])
  const providers = ref([])
  const loading = ref(false)

  async function updateData(search = "") {
    loading.value = true

    await casinoLobbyStore.fetchLobby(search)

    const providersList = casinoLobbyStore.listCasinoLobby.providers || []
    const categoriesList = casinoLobbyStore.listCasinoLobby.categories || []

    categories.value = categoriesList
    providers.value = [...providersList]

    emit("update:categories", categories.value)

    loading.value = false
  }

  return {
    categories,
    providers,
    loading,
    updateData,
  }
}
